import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';

import { setPortal } from 'modules/portal';
import {
  makeRowColumn,
  getHeadObj,
  dataConverter,
  makeHeadData,
  converParameters,
  converDisplayValue,
  converCalFlagData,
  menuAuthCheck,
  conversionParams,
  setNumberFormat,
  getHost,
  // usePrevState,
} from 'lib/commonLib';
import { authUserList } from 'lib/api/auth';
import {
  getMediaTargetNew,
  setParThresHold,
  getParMemoList,
  setParMemo,
  deleteParMemo,
  getTargetWeight,
  setTargetWeight,
} from 'lib/api/media';
import { tableHeaders, targetingCode } from 'lib/api/common';
import { paramConverter } from 'modules/common';
import { showSuccessSnackbar } from 'modules/snackbar';
import { shoppingCustomized } from 'constants/resources/commonCustomize';

import MbTooltip from 'components/atoms/MbTooltip';
import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import VariousCell from 'components/molecules/MbTable/VariousCell';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SortLabelWrap from 'components/molecules/MbTable/SortLabelWrap';

import TargetParRankGraph from './TargetParRankGraph';
import TargetParAdutGraph from './TargetParAdutGraph';
import TargetStatisticsModal from './TargetStatisticsModal';
import TargetStatisticsFilters from './TargetStatisticsFilters';
import { mediaCharacterTpCode } from 'lib/api/code';

import image01 from 'images/common/icon/icon_premium_30x30.png';
import image02 from 'images/common/icon/icon_19_30x30.png';
import image03 from 'images/common/icon/icon_arrow_down_30x30.png';

const useStyles = makeStyles((theme) => ({
  tableColorBox: {
    width: 11,
    height: 11,
    borderRadius: '50%',
    margin: '2px 4px 0 2px',
  },
  productBox: {
    '& > div': { marginBottom: 5, '&:last-child': { marginBottom: 0 } },
  },
}));

const TargetStatistics = React.memo((props) => {
  // 통계보고서 - 매체종합현황판: contactNo, uri, isPop
  // 통계보고서 - 일자별통계 - 구좌별타게팅분포  : sDate, eDate, advrtsPrdtCode, advrtsTpCode, pltfomTpCode, itlTpCode
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { portal, common, auth, allProductCodeList, productCodeList } =
    useSelector(({ portal, common, auth }) => ({
      portal: portal,
      common: common,
      auth: auth['user'],
      allProductCodeList: common.allProductCodeList,
      productCodeList: common.productCodeList,
    }));
  const { location, handleLoading, targeting, tps } = props;
  const { loadingState } = useSelector((state) => state.filter);
  const isDev = `${process.env.NODE_ENV}` === 'development';
  const locationSearch = queryString.parse(location.search);
  const classes = useStyles();

  let initParams = {
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    sort: 'desc',
    order: 'ADVRTS_AMT',
    uri: '/report/media/mediatarget',
    pltfomTpCode: 'all',
    itlTpCode: 'all',
    contactUserId: 'all',
    admContact: 'all',
    prRankTpCode: 'all',
    ssrTpCode: 'all',
    trackerFlag: 'all',
    table: 'short',
    openRtb: 'all',
  };
  const convertKeys = [
    'sDate',
    'eDate',
    'adverId',
    'advrtsPrdtCode',
    'advrtsTpCode',
    'pltfomTpCode',
    'itlTpCode',
    'contactUserId',
  ];

  const initModal = {
    open: false,
    params: {},
    modalTitle: '임계치 수정',
    confirmBtnTitle: '수정',
  };
  const newInitParams = dataConverter(locationSearch, convertKeys);

  initParams = { ...initParams, ...newInitParams };
  // TODO hy_search => 새 테이블 API 필요, 영업담당자 확인 필요
  if (Object.keys(locationSearch).length > 0) {
    const converParams = conversionParams(
      targeting,
      locationSearch,
      allProductCodeList
    );
    initParams = { ...initParams, ...converParams };
    if (!!converParams.contactNo) {
      delete initParams['contactUserId'];
    }
  }
  const [modal, setModal] = useState(initModal);
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [tempParams, setTempParams] = useState(initParams);
  const [tableLoading, setTableLoading] = useState(true);
  const [tableHead, setTableHead] = useState([]);
  const [tableList, setTableList] = useState([]);
  const [tableTotalList, setTableTotalList] = useState({});
  const [missingKey, setMissingKey] = useState([]);
  const [admContactList, setAdmContactList] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [colorBoxOpen, setColorBoxOpen] = useState(true);
  const [targetList, setTargetList] = useState([]);
  const [pcodeList, setPcodeList] = useState({});
  const [authList, setAuthList] = useState([]);
  const [authFlag, setAuthFlag] = useState(false);
  const [reFetch, setReFetch] = useState(false);
  const [mediaCharacterTpCodeList, setMediaCharacterTpCodeList] = useState([]);

  let characterIconList = {};
  const characterImageList = {
    '01': image01
    , '02': image02
    , '03': image03
  };

  const filterList = {
    parRnk: [
      { value: '1', label: 'L01' },
      { value: '2', label: 'L02' },
      { value: '3', label: 'L03' },
      { value: '4', label: 'L04' },
      { value: '5', label: 'L05' },
      { value: '6', label: 'L06' },
      { value: '7', label: 'L07' },
      { value: '8', label: 'L08' },
      { value: '9', label: 'L09' },
      { value: '10', label: 'L10' },
      { value: '11', label: 'L11' },
      { value: '12', label: 'L12' },
    ],
    grade: [
      { value: '1', label: '1등급' },
      { value: '2', label: '2등급' },
      { value: '3', label: '3등급' },
      { value: '4', label: '4등급' },
      { value: '5', label: '5등급' },
      { value: '6', label: '6등급' },
      { value: '7', label: '7등급' },
      { value: '8', label: '8등급' },
      { value: '9', label: '9등급' },
      { value: '10', label: '10등급' },
      { value: '11', label: '11등급' },
      { value: '12', label: '12등급' },
    ],
  };
  const initCustomized = {
    MANAGE_ICONS: {
      makeBody: (rowObj, headsMap) => {
        let weightAutoColor = {};
        const cpcIsY = rowObj['CPC_WEIGHT_AUTO_YN'] === '01';
        if (cpcIsY) {
          weightAutoColor = { backgroundColor: '#79bd2f', border: 'none' };
        }
        return (
          rowObj['FIXED'] !== 0 && (
            <TableBtnWrap direction="vertical">
              <NewButton
                title={t('가중치 자동화 여부')}
                icon="faPowerOff"
                iconBtn
                style={weightAutoColor}
                color={cpcIsY ? '#fff' : undefined}
                disableRipple
              />
              <NewButton
                title={t('임계치 수정')}
                icon="faEdit"
                iconBtn
                onClick={(e) => handleModalOpen('thres', rowObj)}
                disableRipple
              />
              <NewButton
                title={t('타게팅별 가중치현황')}
                icon="faEdit"
                iconBtn
                onClick={(e) => handleModalOpen('target', rowObj)}
                disableRipple
              />
              <NewButton
                title={t('메모')}
                icon="faCommentAltDots"
                iconBtn
                onClick={(e) => handleModalOpen('memo', rowObj)}
                disableRipple
              />
            </TableBtnWrap>
          )
        );
      },
    },
    CHARACTER_CODE: {
      makeBody: (rowObj, headsMap) => {
        let characterCodeArray = [];
        if(!!rowObj['CHARACTER_CODE']) characterCodeArray = rowObj['CHARACTER_CODE'].split(',');

        const contents = [];
        for (let i = 0; i < characterCodeArray.length; i++) {
          let item = characterIconList[characterCodeArray[i]];
            contents.push(
              <>
                <p><img src={item['image']} alt={item['label']} title={item['label']} /></p>
              </>
            );
        }
        return contents;
      },
    },
    SCRIPT_RANK: {
      makeHead: (headsMap) => {
        const text = (
          <>
            * 지면효율등급은 선택한 종료일 전일을 시작으로 90일전 데이터 통계를
            통한 결과가 조회됩니다. <br />* 새벽 시간대( 00~06시) 에는
            전일까지의 등급과 가중치를 산출하기 위해 표기가 되지 않을 수
            있습니다.
          </>
        );
        return (
          <>
            <InfoTitleArea
              title={getHeadObj(headsMap, 'SCRIPT_RANK').label}
              tooltipTitle={text}
              iconType="fainfoCircle"
            />
            {getHeadObj(headsMap, 'CPC_WEIGHT').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'SCRIPT_RANK');
        const bodyItem2 = getHeadObj(headsMap, 'CPC_WEIGHT');

        return (
          rowObj['FIXED'] !== 0 && (
            <>
              {makeRowColumn(
                rowObj['SCRIPT_RANK'],
                bodyItem1.type,
                bodyItem1.format
              )}
              <br />
              {makeRowColumn(
                rowObj['CPC_WEIGHT'],
                bodyItem2.type,
                bodyItem2.format
              )}
            </>
          )
        );
      },
    },
    CPC_WEIGHT_AUTO_YN: { merged: true },
    CPC_WEIGHT: { merged: true },
    GRADE: { merged: true },
    MEDIA_SCRIPT_NO: { merged: true },
    NON_PRDT_FRM_CNT: { merged: true },
    NATIVE_FRM_CNT: { merged: true },
  };
  const [customized, setCustomized] = useState({
    ...initCustomized,
    ...shoppingCustomized,
  });

  const keys = [
    'PAR_EPRS_RATE',
    'ECPM',
    'ADVRTS_AMT',
    'AVG_ADVRTS_AMT',
    'CLICK_RATE',
    'PAR_EPRS_CNT',
    'SESSION_ROAS',
    'ROAS',
  ];

  useEffect(() => {
    authUserList({
      params: { grpNo: isDev ? 64 : 129, uri: '/system/auth/group' },
    })
      .then((response) => {
        setAuthList(response.data.data);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
    authUserList({
      params: { grpNo: isDev ? 20197 : 35, uri: '/system/auth/group' },
    })
      .then((response) => {
        setAdmContactList(response.data.data);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
    authUserList({
      params: { grpNo: isDev ? 20196 : 34, uri: '/system/auth/group' },
    })
      .then((response) => {
        setContactList(response.data.data);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
    targetingCode()
      .then((response) => {
        setTargetList(response.data.data);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
    let newPCodeList = {};
    for (let pCode of common['allProductCodeList']) {
      newPCodeList[pCode[1]['codeVal']] = pCode[1];
    }
    setPcodeList(newPCodeList);
    mediaCharacterTpCode()
      .then((response) => {
        const { data } = response.data;
        setMediaCharacterTpCodeList(data);
        data.map((item) => {
          characterIconList[item['CODE_ID']] = {
            label: t(item['CODE_DESC']),
            image: characterImageList[item['CODE_ID']] != undefined ? characterImageList[item['CODE_ID']] : ''
          }
        });
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
    handleGetList();
    handleCustom(params);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (authList.length > 0)
      setAuthFlag(menuAuthCheck(authList, auth['userid']));
    // eslint-disable-next-line
  }, [authList]);

  useEffect(() => {
    if (
      typeof params['advrtsPrdtCode'] === 'undefined' &&
      !!params['advrtsTpCode']
    ) {
      handleDisplaySnackbar();
    } else if (!!params['advrtsPrdtCode'] && !!params['advrtsTpCode']) {
      const length = params['advrtsTpCode'].split(',').length;
      const prdtLength = productCodeList.get(params['advrtsPrdtCode']).item
        .length;
      if (length === prdtLength) {
      } else if (length > 1) {
        handleDisplaySnackbar();
      }
    }
    // eslint-disable-next-line
  }, [tableHead, params]);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
    if (reFetch === true) {
      handleGetList();
      setReFetch(false);
    } // eslint-disable-next-line
  }, [initialization, reFetch]);

  const handleGetHead = (headParams) => {
    tableHeaders(
      paramConverter({ uri: headParams['uri'], table: headParams['table'] })
    )
      .then((response) => {
        const { data } = response.data;
        setTableHead([
          {
            'id': 'MANAGE_ICONS',
            'label': t('관리'),
            'orderFlag': false,
            'type': 'string',
            'format': '@',
            'displayFlag': true,
            'calFlag': false,
          },
          ...data,
        ]);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
  };

  const handleGetList = (newParams) => {
    handleGetHead(!!newParams ? newParams : params);
    setTableLoading(true);
    getMediaTargetNew({
      params: paramConverter(!!newParams ? newParams : params),
    })
      .then((response) => {
        const datas = response.data.data;
        let newData = [];
        let totalData = [];
        let tempMissing = [];
        if (datas.length > 0) {
          for (let head of tableHead) {
            if (head['calFlag'] !== false && head['calFlag'] !== undefined) {
              tempMissing.push(head['id']);
            }
          }
          for (let data of datas) {
            if (data['FIXED'] !== 0) {
              newData.push({ ...data, MANAGE_ICONS: '' });
            } else {
              totalData = { ...data, MANAGE_ICONS: '' };
            }
          }
        } else {
          newData = [];
          totalData = [];
          tempMissing = [];
        }
        setTableTotalList(totalData);
        setTableList(newData);
        setMissingKey(tempMissing);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .finally(() => {
        setTableLoading(false);
      });
  };

  const handleCustom = (propsParams) => {
    let newCustom = { ...customized };
    for (let key of missingKey) {
      newCustom[key] = {
        makeBody: (rowObj, headsMap) => {
          const bodyItem = getHeadObj(headsMap, key);
          return makeRowColumn(
            converCalFlagData(key, headsMap, rowObj),
            bodyItem.type,
            bodyItem.format
          );
        },
      };
    }
    newCustom = {
      ...newCustom,
      PAR_RNK: {
        makeHead: (headsMap) => {
          const text = (
            <>
              지면 효율 등급은 선택한 종료일 전일을 시작으로 90일전 데이터
              통계를 통한 결과가 조회됩니다. <br />
              *일별 등급 데이터는 ‘사이트’항목 ‘돋보기‘ 아이콘을 클릭해 주세요.
            </>
          );
          return {
            content: (
              <>
                <InfoTitleArea
                  title={getHeadObj(headsMap, 'PAR_RNK').label}
                  tooltipTitle={text}
                  iconType="fainfoCircle"
                />
                {getHeadObj(headsMap, 'GRADE').label}
              </>
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'PAR_RNK');
          const bodyItem2 = getHeadObj(headsMap, 'GRADE');
          const showWindowUrl = converParameters({
            url: getHost() + '/v2/media_report/popup_par_rank_history.php',
            mc: rowObj['MEDIA_SCRIPT_NO'],
            st_date: moment(propsParams.sDate).format('YYYY-MM-DD'),
            en_date: moment(propsParams.eDate).format('YYYY-MM-DD'),
          });
          return (
            rowObj['FIXED'] !== 0 && (
              <>
                <IconAreaWrap
                  text={makeRowColumn(
                    rowObj['PAR_RNK'],
                    bodyItem1.type,
                    bodyItem1.format
                  )}
                  icon="faExternalLink"
                  toolTipTitle={t('해당지면의 등급 상세 팝업')}
                  onClick={(e) => handlePortalUrl(showWindowUrl)}
                />
                {makeRowColumn(
                  rowObj['GRADE'],
                  bodyItem2.type,
                  bodyItem2.format
                )}
              </>
            )
          );
        },
      },
      SCRIPT_NAME: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'SCRIPT_NAME');
          const showWindowUrl = converParameters({
            url: getHost() + '/v2/popup/manage_report_media_day_mc_new.php',
            st_date: moment(propsParams.sDate).format('YYYY-MM-DD'),
            en_date: moment(propsParams.eDate).format('YYYY-MM-DD'),
            mc: rowObj['MEDIA_SCRIPT_NO'],
            gb: converDisplayValue(
              targeting,
              propsParams['advrtsPrdtCode'],
              propsParams['advrtsTpCode']
            ),
            mid: rowObj['MEDIA_ID'],
          });
          return rowObj['FIXED'] !== 0 ? (
            <IconAreaWrap
              text={
                <>
                  {makeRowColumn(
                    rowObj['SCRIPT_NAME'],
                    bodyItem1.type,
                    bodyItem1.format
                  )}
                  ({rowObj['MEDIA_SCRIPT_NO']})
                  <br />
                  {rowObj['MEDIA_ID']}
                  {}
                </>
              }
              icon={rowObj['CORP_NAME'] !== 'total' && 'faExternalLink'}
              toolTipTitle={t('해당 지면의 일자별 통계 new 팝업')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
              lineBreak
            />
          ) : (
            rowObj['SCRIPT_NAME'] +
              (!!rowObj['MEDIA_ID']
                ? '(' + setNumberFormat(rowObj['MEDIA_ID']) + ')'
                : '')
          );
        },
        headStyle: { width: 200 },
        orderFlag: false,
      },
      MEDIA_ID: { merged: true },
      ADVER_CNT: {
        makeHead: (headsMap) => {
          const text = (
            <>
              1. 클릭,소진이 1이상 발생한 광고주 수<br />
              2. 노출,클릭,컨버전 중 데이터가 1이상 발생한 광고주 수
            </>
          );
          return {
            content: (
              <InfoTitleArea
                title={getHeadObj(headsMap, 'ADVER_CNT').label}
                tooltipTitle={text}
                iconType="fainfoCircle"
              />
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'OT_ADVER_CNT');
          const bodyItem2 = getHeadObj(headsMap, 'ADVER_CNT');
          return (
            <>
              <p style={{ fontWeight: 'bold' }}>
                {makeRowColumn(
                  rowObj['OT_ADVER_CNT'],
                  bodyItem1.type,
                  bodyItem1.format
                )}
              </p>
              (
              {makeRowColumn(
                converCalFlagData('ADVER_CNT', headsMap, rowObj),
                bodyItem2.type,
                bodyItem2.format
              )}
              )
            </>
          );
        },
      },
      OT_ADVER_CNT: { merged: true },
      REQ_CNT: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'OLD_REQ_CNT').label}
              <br />
              <SortLabelWrap
                params={propsParams}
                label={getHeadObj(headsMap, 'REQ_CNT').label}
                orderKey="REQ_CNT"
                onClick={(e) => handleSortChange(propsParams, 'REQ_CNT')}
              />
              <br />
              {getHeadObj(headsMap, 'REQ_USED_RATE').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'REQ_CNT');
          const bodyItem2 = getHeadObj(headsMap, 'REQ_USED_RATE');
          const bodyItem3 = getHeadObj(headsMap, 'OLD_REQ_CNT');
          const bodyItem4 = getHeadObj(headsMap, 'OLD_REQ_USED_RATE');
          return (
            <>
              <MbTooltip title={bodyItem3.label}>
              <span style={{ color: theme.palette.common.gray }}>
                {makeRowColumn(
                  converCalFlagData('OLD_REQ_CNT', headsMap, rowObj),
                  bodyItem3.type,
                  bodyItem3.format
                )}
              </span>
              </MbTooltip>
              <MbTooltip title={bodyItem1.label}>
                {makeRowColumn(
                  converCalFlagData('REQ_CNT', headsMap, rowObj),
                  bodyItem1.type,
                  bodyItem1.format
                )}
              </MbTooltip>
              <MbTooltip title={bodyItem4.label}>
                <span style={{ color: theme.palette.common.gray }}>
                ({makeRowColumn(
                  converCalFlagData('OLD_REQ_USED_RATE', headsMap, rowObj),
                  bodyItem4.type,
                  bodyItem4.format
                )})
                </span>
              </MbTooltip>
              <MbTooltip title={bodyItem2.label}>
                ({makeRowColumn(
                    converCalFlagData('REQ_USED_RATE', headsMap, rowObj),
                    bodyItem2.type,
                    bodyItem2.format
                )})
              </MbTooltip>
            </>
          );
        },
        orderFlag: false,
      },
      REQ_USED_RATE: { merged: true },
      OLD_REQ_CNT: { merged: true },
      OLD_REQ_USED_RATE: { merged: true },
      PAR_EPRS_CNT: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'PAR_EPRS_CNT');
          const bodyItem3 = getHeadObj(headsMap, 'CHRG_PAR_EPRS_CNT');
          const bodyItem4 = getHeadObj(headsMap, 'CHRG_RATE');
          return (
            <>
              <MbTooltip title={bodyItem1.label}>
                <span style={{ color: theme.palette.common.blue }}>
                  {makeRowColumn(
                    rowObj['PAR_EPRS_CNT'],
                    bodyItem1.type,
                    bodyItem1.format
                  )}
                </span>
              </MbTooltip>
              <MbTooltip title={bodyItem3.label}>
                <span style={{ color: theme.palette.common.gray }}>
                  {makeRowColumn(
                    rowObj['CHRG_PAR_EPRS_CNT'],
                    bodyItem3.type,
                    bodyItem3.format
                  )}
                </span>
              </MbTooltip>
              <MbTooltip title={bodyItem4.label}>
                (
                {makeRowColumn(
                  converCalFlagData('CHRG_RATE', headsMap, rowObj),
                  bodyItem4.type,
                  bodyItem4.format
                )}
                )
              </MbTooltip>
            </>
          );
        },
      },
      PAR_EPRS_RATE: { merged: true },
      CHRG_PAR_EPRS_CNT: { merged: true },
      CHRG_RATE: { merged: true },
      PRDT_FRM_CNT: {
        makeHead: (headsMap) => {
          return t('프레임수');
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'PRDT_FRM_CNT');
          const bodyItem2 = getHeadObj(headsMap, 'NON_PRDT_FRM_CNT');
          const bodyItem3 = getHeadObj(headsMap, 'NATIVE_FRM_CNT');
          const prdtFrmCntUrl = converParameters({
            url: getHost() + '/Frtb/media_admin/media_report.php',
            sdate: moment(propsParams.sDate).format('YYYY-MM-DD'),
            edate: moment(propsParams.eDate).format('YYYY-MM-DD'),
            mode: 'search',
            par_tp_code: '00',
            is_target: '01',
            searchType: 'mediano',
            textValue: rowObj['MEDIA_SCRIPT_NO'],
          });
          const nonPrdtFrmCntUrl = converParameters({
            url: getHost() + '/Frtb/media_admin/media_report.php',
            sdate: moment(propsParams.sDate).format('YYYY-MM-DD'),
            edate: moment(propsParams.eDate).format('YYYY-MM-DD'),
            mode: 'search',
            par_tp_code: '00',
            is_target: '02',
            searchType: 'mediano',
            textValue: rowObj['MEDIA_SCRIPT_NO'],
          });
          const nativeFrmCntUrl = converParameters({
            url: getHost() + '/NFrtb/media/report.php',
            sdate: moment(propsParams.sDate).format('YYYY-MM-DD'),
            edate: moment(propsParams.eDate).format('YYYY-MM-DD'),
            searchType: 'script_no',
            textValue: rowObj['MEDIA_SCRIPT_NO'],
          });
          return (
            rowObj['FIXED'] !== 0 && (
              <div className={classes.productBox}>
                <IconAreaWrap
                  text={
                    t('상품') +
                    ' : ' +
                    makeRowColumn(
                      rowObj['PRDT_FRM_CNT'],
                      bodyItem1.type,
                      bodyItem1.format
                    )
                  }
                  icon={rowObj['CORP_NAME'] !== 'total' && 'faExternalLink'}
                  toolTipTitle={t('상품')}
                  onClick={() => window.open(prdtFrmCntUrl, '_blank')}
                />
                <IconAreaWrap
                  text={
                    t('비상품') +
                    ' : ' +
                    makeRowColumn(
                      rowObj['NON_PRDT_FRM_CNT'],
                      bodyItem2.type,
                      bodyItem2.format
                    )
                  }
                  icon={rowObj['CORP_NAME'] !== 'total' && 'faExternalLink'}
                  toolTipTitle={t('비상품')}
                  onClick={() => window.open(nonPrdtFrmCntUrl, '_blank')}
                />
                <IconAreaWrap
                  text={
                    t('네이티브') +
                    ' : ' +
                    makeRowColumn(
                      rowObj['NATIVE_FRM_CNT'],
                      bodyItem3.type,
                      bodyItem3.format
                    )
                  }
                  icon={rowObj['CORP_NAME'] !== 'total' && 'faExternalLink'}
                  toolTipTitle={t('네이티브')}
                  onClick={() => window.open(nativeFrmCntUrl, '_blank')}
                />
              </div>
            )
          );
        },
      },
      CLICK_CNT: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'CLICK_CNT');
          const bodyItem2 = getHeadObj(headsMap, 'CHRG_CLICK_CNT');
          const bodyItem3 = getHeadObj(headsMap, 'CHRG_CLICK_RATE');
          const showWindowUrl = converParameters({
            url: getHost() + '/v2/popup/manage_report_adver_detail_new.php',
            st_date: moment(propsParams.sDate).format('YYYY-MM-DD'),
            en_date: moment(propsParams.eDate).format('YYYY-MM-DD'),
            gb: converDisplayValue(
              targeting,
              propsParams['advrtsPrdtCode'],
              propsParams['advrtsTpCode']
            ),
            gb_web: propsParams['pltfomTpCode'],
            mc: rowObj['MEDIA_SCRIPT_NO'],
            isPop: 1,
            baseAddress: '/v2/media_report/manage_report_media_new.php',
          });

          const contents = [];
          contents.push(
              <>
                <MbTooltip title={bodyItem1.label}>
                  {makeRowColumn(
                      rowObj['CLICK_CNT'],
                      bodyItem1.type,
                      bodyItem1.format
                  )}
                </MbTooltip>
              </>
          );

          // 외부연동 제외일 땐 미노출
          if(propsParams['itlTpCode'] === 'all') {
            contents.push(
                <>
                  <MbTooltip title={bodyItem2.label}>
                  <span style={{color: theme.palette.common.gray}}>
                  {makeRowColumn(
                      rowObj['CHRG_CLICK_CNT'],
                      bodyItem2.type,
                      bodyItem2.format
                  )}
                  </span>
                  </MbTooltip>
                  <MbTooltip title={bodyItem3.label}>
                    (
                    {makeRowColumn(
                        converCalFlagData('CHRG_CLICK_RATE', headsMap, rowObj),
                        bodyItem3.type,
                        bodyItem3.format
                    )}
                    )
                  </MbTooltip>
                </>
            );
          }

          return rowObj['FIXED'] !== 0 ? (
            <IconAreaWrap
              text={contents}
              icon="faExternalLink"
              toolTipTitle={t('해당매체의 광고주별통계 팝업')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          ) : (
              <p>{contents}</p>
          );
        },
      },
      CHRG_CLICK_CNT: { merged: true },
      CHRG_CLICK_RATE: { merged: true },
      ORDER_CNT: {
        makeHead: (headsMap) => {
          return (
            <>
              {getHeadObj(headsMap, 'ORDER_CNT').label}
              <br />
              {getHeadObj(headsMap, 'CONV_RATE').label}
              <br />
              {getHeadObj(headsMap, 'CONV_AMT').label}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'ORDER_CNT');
          const bodyItem2 = getHeadObj(headsMap, 'CONV_RATE');
          const bodyItem3 = getHeadObj(headsMap, 'CONV_AMT');
          const showWindowUrl = converParameters({
            url: getHost() + '/v2/popup/daily_conversion.php',
            st_date: moment(propsParams.sDate).format('YYYY-MM-DD'),
            en_date: moment(propsParams.eDate).format('YYYY-MM-DD'),
            gb: converDisplayValue(
              targeting,
              propsParams['advrtsPrdtCode'],
              propsParams['advrtsTpCode']
            ),
            gb_web: propsParams['pltfomTpCode'],
            mc: rowObj['MEDIA_SCRIPT_NO'],
            adExchange_include: propsParams['itlTpCode'] === 'all' ? 'Y' : 'N',
          });
          const contents = [];
          contents.push(
            <>
              <MbTooltip title={bodyItem1.label}>
                {makeRowColumn(
                  rowObj['ORDER_CNT'],
                  bodyItem1.type,
                  bodyItem1.format
                )}
              </MbTooltip>
              <MbTooltip title={bodyItem2.label}>
                {makeRowColumn(
                  converCalFlagData('CONV_RATE', headsMap, rowObj),
                  bodyItem2.type,
                  bodyItem2.format
                )}
              </MbTooltip>
              <MbTooltip title={bodyItem3.label}>
                {makeRowColumn(
                  converCalFlagData('CONV_AMT', headsMap, rowObj),
                  bodyItem3.type,
                  bodyItem3.format
                )}
              </MbTooltip>
            </>
          );

          return rowObj['FIXED'] !== 0 ? (
            <IconAreaWrap
              text={contents}
              icon="faExternalLink"
              toolTipTitle={t('해당매체의 일자별통계 팝업')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          ) : (
            makeRowColumn(rowObj['ORDER_CNT'], bodyItem1.type, bodyItem1.format)
          );
        },
        orderFlag: false,
      },
      ENT_RATE: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'ENT_RATE');
          const bodyItem2 = getHeadObj(headsMap, 'OLD_ENT_RATE');
          return (
            <>
              <MbTooltip title={bodyItem2.label}>
              <span style={{ color: theme.palette.common.gray }}>
              {makeRowColumn(
                  converCalFlagData('OLD_ENT_RATE', headsMap, rowObj),
                  bodyItem2.type,
                  bodyItem2.format
              )}
              </span>
              </MbTooltip>
              <MbTooltip title={bodyItem1.label}>
                {makeRowColumn(
                    converCalFlagData('ENT_RATE', headsMap, rowObj),
                    bodyItem1.type,
                    bodyItem1.format
                )}
              </MbTooltip>
            </>
          );
        },
      },
      OLD_ENT_RATE: { merged: true },
      AVG_ADVRTS_AMT: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'AVG_ADVRTS_AMT');
          const bodyItem2 = getHeadObj(headsMap, 'CPC_MINIMUM_CHARGE');
          const bodyItem3 = getHeadObj(headsMap, 'MIN_ADVRTS_AMT_GOAL_RATE');
          const bodyItem4 = getHeadObj(headsMap, 'PAR_THRES_HOLD');
          return (
            <>
              <MbTooltip title={bodyItem1.label}>
                {t('평균지출현재', {
                  value: makeRowColumn(
                    converCalFlagData('AVG_ADVRTS_AMT', headsMap, rowObj),
                    bodyItem1.type,
                    bodyItem1.format
                  ),
                })}
              </MbTooltip>
              {rowObj['FIXED'] !== 0 && (
                <>
                  <MbTooltip title={bodyItem2.label}>
                    {t('평균지출최소', {
                      value: makeRowColumn(
                        rowObj['CPC_MINIMUM_CHARGE'],
                        bodyItem2.type,
                        bodyItem2.format
                      ),
                    })}
                  </MbTooltip>
                  <MbTooltip title={bodyItem3.label}>
                    {makeRowColumn(
                      converCalFlagData(
                        'MIN_ADVRTS_AMT_GOAL_RATE',
                        headsMap,
                        rowObj
                      ),
                      bodyItem3.type,
                      bodyItem3.format
                    )}
                  </MbTooltip>
                  <MbTooltip title={bodyItem4.label}>
                    {makeRowColumn(
                      rowObj['PAR_THRES_HOLD'],
                      bodyItem4.type,
                      bodyItem4.format
                    )}
                    %
                  </MbTooltip>
                </>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      CPC_MINIMUM_CHARGE: { merged: true },
      MIN_ADVRTS_AMT_GOAL_RATE: { merged: true },
      PAR_THRES_HOLD: { merged: true },
      ECPM: {
        makeHead: (headsMap) => {
          return {
            content: (
              <InfoTitleArea
                title={t('테이블쇼핑타이틀', {
                  label: getHeadObj(headsMap, 'ECPM').label,
                })}
                tooltipTitle={t('테이블쇼핑툴팁ECPM')}
                iconType="fainfoCircle"
              />
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'ECPM');
          const bodyItem2 = getHeadObj(headsMap, 'TRGT_ECPM');
          return (
            <>
              {makeRowColumn(
                converCalFlagData('ECPM', headsMap, rowObj),
                bodyItem1.type,
                bodyItem1.format
              )}
              <br />(
              {makeRowColumn(
                converCalFlagData('TRGT_ECPM', headsMap, rowObj),
                bodyItem2.type,
                bodyItem2.format
              )}
              )
            </>
          );
        },
      },
      TRGT_ECPM: { merged: true },
      ADVRTS_AMT: {
        makeHead: (headsMap) => {
          return (
              <>
                {getHeadObj(headsMap, 'ADVRTS_AMT').label}
                <br />
                ({getHeadObj(headsMap, 'FLT_MC_POINT_RATE').label})
                <br />
                {getHeadObj(headsMap, 'MC_POINT').label}
              </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'ADVRTS_AMT');
          const bodyItem2 = getHeadObj(headsMap, 'FLT_MC_POINT_RATE');
          const bodyItem3 = getHeadObj(headsMap, 'MC_POINT');
          const pointRate =
            converCalFlagData('FLT_MC_POINT_RATE', headsMap, rowObj) * 100;
          return (
            <>
              {makeRowColumn(
                rowObj['ADVRTS_AMT'],
                bodyItem1.type,
                bodyItem1.format
              )}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <p>(</p>
                    {rowObj['FIXED'] !== 0 && (
                    pointRate >= 66 ? (
                        <div
                          className={classes.tableColorBox}
                          style={{ backgroundColor: theme.palette.common.red }}
                        />
                      ) : pointRate < 65 && pointRate >= 51 ? (
                        <div
                          className={classes.tableColorBox}
                          style={{ backgroundColor: theme.palette.common.yellow }}
                        />
                      ) : (
                        <div
                          className={classes.tableColorBox}
                          style={{ backgroundColor: theme.palette.common.green }}
                        />
                    )
                    )}
                    <p>
                      {makeRowColumn(
                        converCalFlagData(
                          'FLT_MC_POINT_RATE',
                          headsMap,
                          rowObj
                        ),
                        bodyItem2.type,
                        bodyItem2.format
                      )}
                      )
                    </p>
                  </div>
                  <p style={{ color: theme.palette.common.gray }}>
                    {makeRowColumn(
                      converCalFlagData('MC_POINT', headsMap, rowObj),
                      bodyItem3.type,
                      bodyItem3.format
                    )}
                  </p>
                </>
          );
        },
      },
      FLT_MC_POINT_RATE: { merged: true },
      MC_POINT: { merged: true },
      MOB_SESSION_ROAS: {
        makeHead: (headsMap) => {
          return {
            content: (
              <InfoTitleArea
                title={t('테이블쇼핑타이틀', {
                  label: getHeadObj(headsMap, 'MOB_SESSION_ORDER_AMT').label,
                })}
                tooltipTitle={t('테이블쇼핑툴팁MOB_SESSION_ORDER_AMT')}
                iconType="fainfoCircle"
              />
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'MOB_SESSION_ROAS');
          const bodyItem2 = getHeadObj(headsMap, 'TRGT_MOB_SESSION_ROAS');
          const bodyItem3 = getHeadObj(headsMap, 'MOB_SESSION_ORDER_AMT');
          return (
            <VariousCell
              type="TRGT"
              bold
              item1={makeRowColumn(
                converCalFlagData('MOB_SESSION_ROAS', headsMap, rowObj),
                bodyItem1.type,
                bodyItem1.format
              )}
              item2={makeRowColumn(
                converCalFlagData('TRGT_MOB_SESSION_ROAS', headsMap, rowObj),
                bodyItem2.type,
                bodyItem2.format
              )}
              item3={makeRowColumn(
                rowObj['MOB_SESSION_ORDER_AMT'],
                bodyItem3.type,
                bodyItem3.format
              )}
            />
          );
        },
      },
      TRGT_MOB_SESSION_ROAS: { merged: true },
      MOB_SESSION_ORDER_AMT: { merged: true },
      BROWSER_SESSION_ROAS: {
        makeHead: (headsMap) => {
          return {
            content: (
              <InfoTitleArea
                title={t('테이블쇼핑타이틀', {
                  label: getHeadObj(headsMap, 'BROWSER_SESSION_ORDER_AMT')
                    .label,
                })}
                tooltipTitle={t('테이블쇼핑툴팁BROWSER_SESSION_ORDER_AMT')}
                iconType="fainfoCircle"
              />
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'BROWSER_SESSION_ROAS');
          const bodyItem2 = getHeadObj(headsMap, 'TRGT_BROWSER_SESSION_ROAS');
          const bodyItem3 = getHeadObj(headsMap, 'BROWSER_SESSION_ORDER_AMT');
          return (
            <VariousCell
              type="TRGT"
              bold
              item1={makeRowColumn(
                converCalFlagData('BROWSER_SESSION_ROAS', headsMap, rowObj),
                bodyItem1.type,
                bodyItem1.format
              )}
              item2={makeRowColumn(
                converCalFlagData(
                  'TRGT_BROWSER_SESSION_ROAS',
                  headsMap,
                  rowObj
                ),
                bodyItem2.type,
                bodyItem2.format
              )}
              item3={makeRowColumn(
                rowObj['BROWSER_SESSION_ORDER_AMT'],
                bodyItem3.type,
                bodyItem3.format
              )}
            />
          );
        },
      },
      TRGT_BROWSER_SESSION_ROAS: { merged: true },
      BROWSER_SESSION_ORDER_AMT: { merged: true },
      SESSION_ROAS: {
        makeHead: (headsMap) => {
          return {
            content: (
              <InfoTitleArea
                title={t('테이블쇼핑타이틀', {
                  label: getHeadObj(headsMap, 'SESSION_ORDER_AMT').label,
                })}
                tooltipTitle={t('테이블쇼핑툴팁SESSION_ORDER_AMT')}
                iconType="fainfoCircle"
              />
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'SESSION_ROAS');
          const bodyItem2 = getHeadObj(headsMap, 'TRGT_SESSION_ROAS');
          const bodyItem3 = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
          return (
            <VariousCell
              type="TRGT"
              bold
              item1={makeRowColumn(
                converCalFlagData('SESSION_ROAS', headsMap, rowObj),
                bodyItem1.type,
                bodyItem1.format
              )}
              item2={makeRowColumn(
                converCalFlagData('TRGT_SESSION_ROAS', headsMap, rowObj),
                bodyItem2.type,
                bodyItem2.format
              )}
              item3={makeRowColumn(
                rowObj['SESSION_ORDER_AMT'],
                bodyItem3.type,
                bodyItem3.format
              )}
            />
          );
        },
      },
      TRGT_SESSION_ROAS: { merged: true },
      SESSION_ORDER_AMT: { merged: true },
      DIRECT_ROAS: {
        makeHead: (headsMap) => {
          return {
            content: (
              <InfoTitleArea
                title={t('테이블쇼핑타이틀', {
                  label: getHeadObj(headsMap, 'DIRECT_ORDER_AMT').label,
                })}
                tooltipTitle={t('테이블쇼핑툴팁DIRECT_ORDER_AMT')}
                iconType="fainfoCircle"
              />
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'DIRECT_ROAS');
          const bodyItem2 = getHeadObj(headsMap, 'TRGT_DIRECT_ROAS');
          const bodyItem3 = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
          return (
            <VariousCell
              type="TRGT"
              bold
              item1={makeRowColumn(
                converCalFlagData('DIRECT_ROAS', headsMap, rowObj),
                bodyItem1.type,
                bodyItem1.format
              )}
              item2={makeRowColumn(
                converCalFlagData('TRGT_DIRECT_ROAS', headsMap, rowObj),
                bodyItem2.type,
                bodyItem2.format
              )}
              item3={makeRowColumn(
                rowObj['DIRECT_ORDER_AMT'],
                bodyItem3.type,
                bodyItem3.format
              )}
            />
          );
        },
      },
      TRGT_DIRECT_ROAS: { merged: true },
      DIRECT_ORDER_AMT: { merged: true },
      ROAS: {
        makeHead: (headsMap) => {
          return {
            content: (
              <InfoTitleArea
                title={t('테이블쇼핑타이틀', {
                  label: getHeadObj(headsMap, 'ORDER_AMT').label,
                })}
                tooltipTitle={t('테이블쇼핑툴팁ORDER_AMT')}
                iconType="fainfoCircle"
              />
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'ROAS');
          const bodyItem2 = getHeadObj(headsMap, 'TRGT_ROAS');
          const bodyItem3 = getHeadObj(headsMap, 'ORDER_AMT');
          return (
            <VariousCell
              type="TRGT"
              bold
              item1={makeRowColumn(
                converCalFlagData('ROAS', headsMap, rowObj),
                bodyItem1.type,
                bodyItem1.format
              )}
              item2={makeRowColumn(
                converCalFlagData('TRGT_ROAS', headsMap, rowObj),
                bodyItem2.type,
                bodyItem2.format
              )}
              item3={makeRowColumn(
                rowObj['ORDER_AMT'],
                bodyItem3.type,
                bodyItem3.format
              )}
            />
          );
        },
      },
      TRGT_ROAS: { merged: true },
      ORDER_AMT: { merged: true },
      CLICK_RATE: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'CLICK_RATE');
          return makeRowColumn(
            converCalFlagData('CLICK_RATE', headsMap, rowObj),
            bodyItem1.type,
            bodyItem1.format
          );
        },
      },
      CONV_RATE: { merged: true },
      CONV_AMT: { merged: true },
      AVG_ORDER_AMT: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'AVG_ORDER_AMT');
          return makeRowColumn(
            converCalFlagData('AVG_ORDER_AMT', headsMap, rowObj),
            bodyItem1.type,
            bodyItem1.format
          );
        },
      },
      CONTACT_NAME: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'CONTACT_NAME');
          return (
            rowObj['FIXED'] !== 0 &&
            makeRowColumn(
              rowObj['CONTACT_NAME'],
              bodyItem1.type,
              bodyItem1.format
            )
          );
        },
      },
      SYD_NAME: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'SYD_NAME');
          return (
            rowObj['FIXED'] !== 0 &&
            makeRowColumn(rowObj['SYD_NAME'], bodyItem1.type, bodyItem1.format)
          );
        },
      },
      EX_USER_CNT: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'EX_USER_CNT');
          const showWindowUrl = converParameters({
            url: getHost() + '/v2/popup/pop_mc_ex.php',
            gb: converDisplayValue(
              targeting,
              propsParams['advrtsPrdtCode'],
              propsParams['advrtsTpCode']
            ),
            st_date: moment(propsParams.sDate).format('YYYY-MM-DD'),
            en_date: moment(propsParams.eDate).format('YYYY-MM-DD'),
            media_id: rowObj['MEDIA_ID'],
          });
          return rowObj['FIXED'] !== 0 ? (
            <IconAreaWrap
              text={makeRowColumn(
                rowObj['EX_USER_CNT'],
                bodyItem1.type,
                bodyItem1.format
              )}
              icon="faExternalLink"
              toolTipTitle={t('해당매체의 외부연동 팝업')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          ) : (
            makeRowColumn(
              rowObj['EX_USER_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )
          );
        },
      },
    };
    for (let i = 0; tps.length > i; i++) {
      let keyName;
      for (let key of keys) {
        keyName = tps[i] + '_' + key;
        if (key === 'PAR_EPRS_CNT') {
          newCustom[keyName] = {
            makeHead: (headsMap) => {
              let headLabel = tps[i];
              if (tps[i] === 'EX') {
                headLabel = t('외부연동') + '(' + tps[i] + ')';
              } else {
                for (let target of targetList) {
                  if (headLabel === target['CODE_VAL']) {
                    headLabel = target['CODE_DESC'];
                    break;
                  }
                }
              }
              return headLabel;
            },
            makeBody: (rowObj, headsMap) => {
              const bodyItem1 = getHeadObj(headsMap, tps[i] + '_PAR_EPRS_CNT');
              const bodyItem2 = getHeadObj(headsMap, tps[i] + '_PAR_EPRS_RATE');
              const bodyItem3 = getHeadObj(headsMap, tps[i] + '_ECPM');
              const bodyItem4 = getHeadObj(headsMap, tps[i] + '_ADVRTS_AMT');
              const bodyItem5 = getHeadObj(
                headsMap,
                tps[i] + '_AVG_ADVRTS_AMT'
              );
              const bodyItem6 = getHeadObj(headsMap, tps[i] + '_CLICK_RATE');
              const bodyItem7 = getHeadObj(headsMap, tps[i] + '_SESSION_ROAS');
              const bodyItem8 = getHeadObj(headsMap, tps[i] + '_ROAS');
              return (
                <>
                  <MbTooltip title={t('구좌노출수')}>
                    {makeRowColumn(
                      converCalFlagData(
                        tps[i] + '_PAR_EPRS_CNT',
                        headsMap,
                        rowObj,
                        true
                      ),
                      bodyItem1.type,
                      bodyItem1.format
                    )}
                    {tps[i] === 'EX' ? (
                      <>
                        (
                        {makeRowColumn(
                          rowObj['EX_PAR_EPRS_CNT'] /
                            rowObj['EX_PAR_EPRS_CNT '],
                          bodyItem2.type,
                          bodyItem2.format
                        )}
                        )
                      </>
                    ) : (
                      <>
                        (
                        {makeRowColumn(
                          converCalFlagData(
                            tps[i] + '_PAR_EPRS_RATE',
                            headsMap,
                            rowObj,
                            true
                          ),
                          bodyItem2.type,
                          bodyItem2.format
                        )}
                        )
                      </>
                    )}
                  </MbTooltip>
                  <MbTooltip title={t('ECPM')}>
                    <span className="green">
                      (
                      {makeRowColumn(
                        converCalFlagData(
                          tps[i] + '_ECPM',
                          headsMap,
                          rowObj,
                          true
                        ),
                        bodyItem3.type,
                        bodyItem3.format
                      )}
                      )
                    </span>
                  </MbTooltip>
                  <MbTooltip title={t('지출금액')}>
                    <span className="red">
                      (
                      {makeRowColumn(
                        converCalFlagData(
                          tps[i] + '_ADVRTS_AMT',
                          headsMap,
                          rowObj,
                          true
                        ),
                        bodyItem4.type,
                        bodyItem4.format
                      )}
                      )
                    </span>
                  </MbTooltip>
                  <MbTooltip title={t('평균지출')}>
                    <span className="black">
                      (
                      {makeRowColumn(
                        converCalFlagData(
                          tps[i] + '_AVG_ADVRTS_AMT',
                          headsMap,
                          rowObj,
                          true
                        ),
                        bodyItem5.type,
                        bodyItem5.format
                      )}
                      )
                    </span>
                  </MbTooltip>
                  <MbTooltip title={'CTR'}>
                    <span className="blue">
                      {makeRowColumn(
                        converCalFlagData(
                          tps[i] + '_CLICK_RATE',
                          headsMap,
                          rowObj,
                          true
                        ),
                        bodyItem6.type,
                        bodyItem6.format
                      )}
                    </span>
                  </MbTooltip>
                  {tps[i] !== 'EX' && (
                    <>
                      <MbTooltip title={t('세션ROAS')}>
                        <span className="green">
                          {makeRowColumn(
                            converCalFlagData(
                              tps[i] + '_SESSION_ROAS',
                              headsMap,
                              rowObj,
                              true
                            ),
                            bodyItem7.type,
                            bodyItem7.format
                          )}
                        </span>
                      </MbTooltip>
                      <MbTooltip title={t('총ROAS')}>
                        <span style={{ color: theme.palette.common.purple }}>
                          {makeRowColumn(
                            converCalFlagData(
                              tps[i] + '_ROAS',
                              headsMap,
                              rowObj,
                              true
                            ),
                            bodyItem8.type,
                            bodyItem8.format
                          )}
                        </span>
                      </MbTooltip>
                    </>
                  )}
                </>
              );
            },
            orderFlag: false,
          };
        } else {
          newCustom[keyName] = { merged: true };
        }
      }
    }
    setCustomized(newCustom);
  };

  const handleOnReset = () => {
    if (
      JSON.stringify(params) !== JSON.stringify(initParams) ||
      JSON.stringify(tempParams) !== JSON.stringify(initParams)
    ) {
      setInitialization(true);
      setParams(initParams);
      setTempParams(initParams);
    }
  };

  const getParam = (newParams, name) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      let tempParams = { ...newParams };
      if (name === 'filter') {
        //delete tempParams['keyword'];
        handleGetList(tempParams);
      } else if (
        name !== 'order' &&
        name !== 'sort' &&
        //name !== 'keyword' &&
        typeof name !== 'undefined'
      ) {
        handleGetList(tempParams);
      }
      handleCustom(tempParams);
      setParams(tempParams);
      setTempParams(tempParams);
    }
  };

  const getTempParam = (newParams) => {
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
      handleCustom(params);
    }
  };

  const getModalParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setModal({ ...modal, params: newParams });
    }
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const handleColorBox = (key, value) => {
    setColorBoxOpen(true);
    const newParams = { ...tempParams, [key]: value };
    getTempParam(newParams);
    setColorBoxOpen(false);
  };

  const handleLabelConver = (key) => {
    let newLabel = '';
    if (key === 'prRankTpCode') {
      switch (tempParams[key]) {
        case '01':
          newLabel = '66% 이상';
          break;
        case '02':
          newLabel = '51% ~ 65%';
          break;
        case '03':
          newLabel = '50% 이하';
          break;
        default:
          newLabel = '';
          break;
      }
    } else if (key === 'ssrTpCode') {
      switch (tempParams[key]) {
        case '01':
          newLabel = '50% 미만';
          break;
        case '02':
          newLabel = '50% 이상 ~ 100% 미만';
          break;
        case '03':
          newLabel = '100% 이상 ~ 200% 미만';
          break;
        case '04':
          newLabel = '200% 이상 ~ 500% 미만';
          break;
        case '05':
          newLabel = '500% 이상';
          break;
        default:
          newLabel = '';
          break;
      }
    }
    return newLabel;
  };

  const handleModalOpen = (type, rowObj) => {
    let newModal = { ...initModal, open: true, type: type };
    if (type === 'thres') {
      newModal = {
        ...newModal,
        params: {
          mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'],
          parThresHold: rowObj['PAR_THRES_HOLD'],
          prevValue: rowObj['PAR_THRES_HOLD'],
        },
        modalTitle: '임계치 수정',
        confirmBtnTitle: '수정',
      };
      setModal(newModal);
    } else if (type === 'memo') {
      handleLoading(true);
      handleGetMemoList(newModal, rowObj['MEDIA_SCRIPT_NO']);
    } else if (type === 'target') {
      handleLoading(true);
      newModal = {
        ...newModal,
        params: { mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'] },
        modalTitle: '타게팅별 가중치현황',
      };
      getTargetWeight({
        params: { mediaScriptNo: newModal.params.mediaScriptNo },
      })
        .then((response) => {
          let newData = {};
          const { data, lastDttm } = response.data.data;
          if (data.length > 0) {
            for (let i in data) {
              newData[data[i]['CODE_VAL']] = data[i]['ADVRTS_WGHTVAL_VAL'];
            }
            newModal = {
              ...newModal,
              params: {
                ...newModal.params,
                mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'],
                siteName: rowObj['SCRIPT_NAME'],
                lastDttm: lastDttm,
                ...newData,
              },
              data: { ...newData },
              modalTitle: '타게팅별 가중치현황',
            };
          } else {
            newModal = {
              ...newModal,
              params: {
                ...newModal.params,
                mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'],
                siteName: rowObj['SCRIPT_NAME'],
              },
              data: { noData: true },
              modalTitle: t('타게팅별 가중치현황'),
              confirmBtnOpen: false,
              cancelBtnTitle: t('확인'),
            };
          }
        })
        .catch((error) => {
          handleClickSnackbar({ message: error, option: { type: 'error' } });
        })
        .finally(() => {
          handleLoading(false);
          setModal(newModal);
        });
    } else if (type === 'targets') {
      newModal = {
        ...newModal,
        params: { ...newModal.params, mediaScriptNo: rowObj },
        modalTitle: t('타게팅별 가중치 비율 일괄적용'),
        confirmBtnTitle: t('확인'),
      };
      setModal(newModal);
    }
  };

  const handleGetMemoList = (propsParams, mediaScriptNo) => {
    let newModal = { ...propsParams };
    if (!!mediaScriptNo) {
      newModal = { ...newModal, params: { mediaScriptNo: mediaScriptNo } };
    }
    newModal = {
      ...newModal,
      open: true,
      type: 'memo',
      modalTitle: t('메모'),
      confirmBtnOpen: false,
      cancelBtnTitle: t('확인'),
    };
    getParMemoList({ params: { mediaScriptNo: newModal.params.mediaScriptNo } })
      .then((response) => {
        newModal = { ...newModal, data: response.data.data };
        setModal(newModal);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .finally(() => {
        handleLoading(false);
      });
  };

  const handleModalClose = () => {
    setModal({ ...modal, open: false });
  };

  const handleSubmit = () => {
    const { type } = modal;
    if (type === 'thres') {
      if (modal.params.parThresHold === modal.params.prevValue) {
        handleClickSnackbar({
          message: t('임계치가 동일합니다.'),
          option: { type: 'error' },
        });
      } else {
        handleLoading(true);
        setParThresHold(modal.params)
          .then((response) => {
            handleClickSnackbar({
              message: response.data.message,
              option: { type: 'success' },
            });
            handleGetList();
          })
          .catch((error) => {
            handleClickSnackbar({ message: error, option: { type: 'error' } });
            handleLoading(false);
          })
          .finally(() => {
            handleModalClose();
          });
      }
    } else if (type === 'target') {
      let changeData = {};
      for (let targetKey in modal['data']) {
        if (modal['data'][targetKey] !== Number(modal['params'][targetKey])) {
          changeData[targetKey] = Number(modal['params'][targetKey]);
        }
      }
      handleSetTarget({
        mediaScriptNo: String(modal['params']['mediaScriptNo']),
        ...changeData,
      });
    } else if (type === 'targets') {
      handleSetTarget({
        mediaScriptNo: modal['params']['mediaScriptNo'],
        [modal['params']['key']]: modal['params']['value'],
      });
    }
  };

  const handleSetTarget = (parameters) => {
    handleLoading(true);
    setTargetWeight(parameters)
      .then((response) => {
        handleClickSnackbar({
          message: response.data.message,
          option: { type: 'success' },
        });
        handleModalClose();
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .finally(() => {
        handleLoading(false);
      });
  };

  const handleSetMemo = (parameters) => {
    setParMemo(parameters)
      .then((response) => {
        handleClickSnackbar({
          message: response.data.message,
          option: { type: 'success' },
        });
        handleGetMemoList({
          ...modal,
          params: { mediaScriptNo: modal.params.mediaScriptNo },
        });
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
  };

  const handleMemo = (type, rowObj) => {
    let newModal = { ...modal, params: { ...modal.params } };
    if (type === 'delete') {
      handleLoading(true);
      deleteParMemo(rowObj['MEMO_NO'])
        .then((response) => {
          handleClickSnackbar({
            message: response.data.message,
            option: { type: 'success' },
          });
          delete newModal['params']['memoNo'];
          delete newModal['params']['memo'];
          handleGetMemoList(newModal);
        })
        .catch((error) => {
          handleClickSnackbar({ message: error, option: { type: 'error' } });
        })
        .finally(() => handleLoading(true));
    } else if (type === 'modify') {
      if (modal['params']['memoNo'] === rowObj['MEMO_NO']) {
        delete newModal['params']['memoNo'];
        delete newModal['params']['memo'];
      } else {
        newModal = {
          ...newModal,
          params: {
            ...newModal.params,
            memoNo: rowObj['MEMO_NO'],
            memo: rowObj['TEXT'],
          },
        };
      }
    } else if (type === 'set' || type === 'add') {
      // handleLoading(true);
      handleSetMemo(newModal['params']);
    }
    setModal(newModal);
  };

  const handleSortChange = (propsParams, orderKey) => {
    const { order, sort } = propsParams;
    const isDesc = order === orderKey && sort === 'desc';
    const converSort = isDesc ? 'asc' : 'desc';
    const newParams = { ...propsParams, order: orderKey, sort: converSort };
    setParams(newParams);
    handleCustom(newParams);
  };

  const handleCheckBtnController = (type, data) => {
    let tmpExlNo = [];
    data.forEach(function (rowData) {
      tmpExlNo.push(rowData['MEDIA_SCRIPT_NO']);
    });
    handleModalOpen('targets', String(tmpExlNo));
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  const handleDisplaySnackbar = () => {
    handleClickSnackbar({
      message: t('팝업 사용 시 1.0과 2.0은 필터가 호환되지 않을 수 있습니다.'),
      option: { type: 'info' },
    });
  };

  return (
    <>
      <TargetStatisticsFilters
        tempParams={tempParams}
        filterList={filterList}
        admContactList={admContactList}
        contactList={contactList}
        colorBoxOpen={colorBoxOpen}
        initialization={initialization}
        getParam={getParam}
        handleOnReset={handleOnReset}
        handleColorBox={handleColorBox}
        handleLabelConver={handleLabelConver}
        getTempParam={getTempParam}
        reFetch={reFetch}
        mediaCharacterTpCodeList={mediaCharacterTpCodeList}
        handleOnReSearch={(f) => setReFetch(true)}
      />
      <TargetParRankGraph
        params={{
          sDate: moment(params['eDate']).add(-90, 'day').format('YYYYMMDD'),
          eDate: moment(params['eDate']).add(-1, 'day').format('YYYYMMDD'),
          order: 'parRnk',
          parRnkDate: params['eDate'],
        }}
        handleClickSnackbar={handleClickSnackbar}
        reFetch={reFetch}
      />
      <TargetParAdutGraph
        params={{
          sDate: params['sDate'],
          eDate: params['eDate'],
          order: 'rank',
        }}
        handleClickSnackbar={handleClickSnackbar}
        reFetch={reFetch}
        loading={tableLoading}
      />
      <NewButton
        onClick={() =>
          getParam(
            { ...params, table: params['table'] === 'short' ? 'all' : 'short' },
            'table'
          )
        }
        disableRipple
        disabled={loadingState.table}
      >
        {params['table'] === 'short' ? t('테이블 펼치기') : t('테이블 접기')}
      </NewButton>
      <NewTableContainer
        params={params}
        getParam={getParam}
        customized={customized}
        dataReqPromise={getMediaTargetNew}
        useCustomTable
        useTotalSubList={false}
        propsList={tableList}
        propsTotalList={tableTotalList}
        propsHeadCells={makeHeadData(tableHead)}
        useFetch={false}
        loading={tableLoading}
        rowsPerPage={10}
        rowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
        useCheckBox={authFlag}
        headCallBack={handleCheckBtnController}
      />
      {modal.open && (
        <TargetStatisticsModal
          modal={modal}
          params={params}
          handleModalClose={handleModalClose}
          handleSubmit={handleSubmit}
          getModalParam={getModalParam}
          handleModalOpen={handleModalOpen}
          handleMemo={handleMemo}
          pcodeList={pcodeList}
        />
      )}
    </>
  );
});

const isEqual = (prefProps, nextProps) => {
  let equal = JSON.stringify(prefProps) !== JSON.stringify(nextProps);
  return !equal;
};

export default React.memo(withRouter(TargetStatistics), isEqual);
